module.exports = __webpack_public_path__ + "img/Y002.fc8d7ebc.jpg";